import _ from "lodash";
import { LoadStatus } from "../../enums/enums";
import { getActiveDomain } from "../../helpers/websites/getActiveDomain";
import addNoCacheParamToURL from "../../helpers/editor/addNoCacheParamToURL";
import { toggleIsCreateWebhookWaitingForServer } from "../websites/actions";
import {
  getCurrentStoreData,
  savePartialWebsiteData,
} from "../websites/thunks";
import { createBlogAsync } from "../../helpers/async/createBlogAsync";
import {
  DEFAULT_ERROR_MESSAGE,
  DEFAULT_ERROR_TITLE,
  defaultBlogUrl,
  notificationDuration,
} from "../../data/constants";
import {
  saveSingleBlogInState,
  setSingleBlogLoadStatus,
  toggleBlogFooterEditionsDetected,
  toggleBlogNavEditionsDetected,
  toggleWaitingForResponseOnBlogNavEditions,
} from "./actions";
import { setInitialPostsStatus } from "../blogPosts/actions";
import { openNotification } from "../../helpers/openNotification";
import { manageWebhooksAsync } from "../../helpers/async/manageWebhooksAsync";
import { message } from "antd";
import { api } from "../../data/urls";
import axios from "axios";
import returnAuthHeaderForAJAX from "../../helpers/auth/returnAuthHeaderForAJAX";
import { handleBadWebsiteError } from "../../helpers/handleBadWebsiteError";

export const getSingleBlogLoadStatus = (blog) => {
  return (dispatch, getState) => {
    const blogs = getState().blogs;
    if (!blog && blogs.dataFetched) {
      return LoadStatus.LOADED;
    }
    if (!blog) {
      return LoadStatus.NO_DATA;
    }
    const currentStatus = blogs.singleBlogLoadStatusArray.find((item) => {
      return item.blogId === blog.id;
    });
    return _.get(currentStatus, "status", LoadStatus.NOT_LOADED);
  };
};

export const previewBlogHomePage = (blogId: number) => {
  return (dispatch, getState) => {
    const blog = getState().blogs.items.find((item) => item.id === blogId);
    if (!blog) return;
    const website = getState().websites.items.find(
      (item) => item.id === blog.website
    );
    if (!website) return;
    let protocol = "https://";
    if (process.env.REACT_APP_API_URL === "http://app.unicorn.com:8000") {
      protocol = "http://";
    }
    let fullUrl = getActiveDomain(website) + "/" + blog.url;
    fullUrl = protocol + fullUrl;
    if (!fullUrl.endsWith("/")) {
      fullUrl += "/";
    }
    window.open(addNoCacheParamToURL(fullUrl), `blogHomePreview-${blogId}`);
  };
};

export const generateBlogApiToken = (successCallback: any) => {
  return async (dispatch, getState) => {
    const { auth } = getState();
    const { currentWebsite } = dispatch(getCurrentStoreData());
    dispatch(toggleIsCreateWebhookWaitingForServer(true));

    let currentBlog = dispatch(getCurrentStoreData()).currentBlog;

    const createBlog = async () => {
      return await createBlogAsync({
        accessToken: auth.accessToken,
        subdomain: currentWebsite.subdomain,
        newBlogUrl: defaultBlogUrl,
        websiteId: currentWebsite.id,
      })
        .then(({ data }) => {
          dispatch(
            setSingleBlogLoadStatus({
              blogId: data.id,
              status: LoadStatus.LOADED,
            })
          );
          dispatch(
            setInitialPostsStatus({
              blogId: data.id,
              status: LoadStatus.LOADED,
            })
          );
          dispatch(saveSingleBlogInState([data]));
          currentBlog = data;
          // if (currentBlog) {
          //   setBlogUrl(currentBlog.url);
          // }
          return data;
        })
        .catch((error) => {
          console.error(error.response);
          openNotification(
            DEFAULT_ERROR_TITLE,
            DEFAULT_ERROR_MESSAGE,
            "OK",
            "error",
            notificationDuration.medium
          );
        });
    };

    if (!currentBlog) {
      const response = await createBlog();
      if (!response) {
        toggleIsCreateWebhookWaitingForServer(false);
        return;
      }
    }
    console.log("TEST 1");
    manageWebhooksAsync({
      webhook_name: "seobot",
      accessToken: auth.accessToken,
      websiteId: currentWebsite.id,
    })
      .then((response) => {
        dispatch(
          savePartialWebsiteData({
            websiteId: currentWebsite.id,
            data: {
              webhooks: {
                ...currentWebsite.webhooks,
                seobot: response.data.webhook_token,
              },
            },
          })
        );
        message.success("API key generated successfully", 2);
        if (successCallback) {
          successCallback(response.data.webhook_token);
        }
      })
      .catch((error) => {
        console.error(error);
        const errorMessage = _.get(
          error,
          ["response", "data", "message"],
          "Could not create webhook. Please contact us."
        );
        message.error(`Error: ${errorMessage}`);
        const existingWebhookToken = _.get(currentWebsite, "webhooks.seobot");
        console.log("existingWebhookToken: ", existingWebhookToken);
        if (existingWebhookToken) {
          successCallback(existingWebhookToken);
        }
      })
      .finally(() => {
        toggleIsCreateWebhookWaitingForServer(false);
      });
  };
};

export const saveBlogNavInServer = () => {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const { currentBlog } = dispatch(getCurrentStoreData());
    if (!currentBlog) return;
    const accessToken = auth.accessToken;
    const apiUrl =
      api.blogs.updateBlog.prefix +
      currentBlog.id +
      api.blogs.updateBlog.postfix;
    return new Promise((resolve, reject) => {
      axios
        .patch(
          apiUrl,
          { nav: currentBlog.nav },
          { ...returnAuthHeaderForAJAX(accessToken) }
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response) {
            let errorData = error.response.data;

            handleBadWebsiteError(errorData);

            if (errorData.not_pro !== undefined) {
              let message = errorData.not_pro;
              openNotification("Denied", message, "OK", "warn");
            }

            if (errorData.locked !== undefined) {
              let message = errorData.locked;
              openNotification("Denied", message, "OK", "warn");
            }

            if (errorData.detail !== undefined) {
              let message = errorData.detail;

              openNotification(
                "Server error",
                'Error message: "' +
                  message +
                  '". This should not have happened. Please contact us.',
                "OK",
                "error"
              );
            }
          }
          reject(error);
        })
        .then((response) => {
          dispatch(toggleBlogNavEditionsDetected(false));
          dispatch(toggleWaitingForResponseOnBlogNavEditions(false));
        });
    });
  };
};

export const saveBlogFooterInServer = () => {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const { currentBlog } = dispatch(getCurrentStoreData());
    const accessToken = auth.accessToken;
    const apiUrl =
      api.blogs.updateBlog.prefix +
      currentBlog.id +
      api.blogs.updateBlog.postfix;

    return new Promise((resolve, reject) => {
      axios
        .patch(
          apiUrl,
          { footer: currentBlog.footer },
          { ...returnAuthHeaderForAJAX(accessToken) }
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response) {
            let errorData = error.response.data;

            handleBadWebsiteError(errorData);

            if (errorData.not_pro !== undefined) {
              let message = errorData.not_pro;
              openNotification("Denied", message, "OK", "warn");
            }

            if (errorData.locked !== undefined) {
              let message = errorData.locked;
              openNotification("Denied", message, "OK", "warn");
            }

            if (errorData.detail !== undefined) {
              let message = errorData.detail;

              // This happens when user tries to change a website which doesn't exist or doesn't belong to the user.
              openNotification(
                "Server error",
                'Error message: "' +
                  message +
                  '". This should not have happened. Please contact us.',
                "OK",
                "error"
              );
            }
          }
          reject(error);
        })
        .then((response) => {
          dispatch(toggleBlogFooterEditionsDetected(false));
          dispatch(toggleWaitingForResponseOnBlogNavEditions(false));
        });
    });
  };
};
